// extracted by mini-css-extract-plugin
var _1 = "iconClass-TXH8";
export { _1 as "iconClass" }
